export function bindCardSliderControls() {
  const controls_prev = document.querySelectorAll(".js-card-slider-controls-prev");
  const controls_next = document.querySelectorAll(".js-card-slider-controls-next");
  for (let i = 0; i < controls_prev.length; i++) {
    controls_prev[i].addEventListener("click", () => {
      if (
        "id" in controls_prev.dataset &&
        "event" in controls_prev.dataset &&
        controls_prev.dataset.event == "henley-splide-prev-course-card-slide"
      ) {
        window.dispatchEvent(
          new CustomEvent(`henley-splide-prev-course-card-slide-${controls_prev.dataset}`)
        );
      } else if (
        "id" in controls_prev.dataset &&
        "event" in controls_prev.dataset &&
        controls_prev.dataset.event == "henley-splide-prev-course-image-carousel"
      ) {
        window.dispatchEvent(
          new CustomEvent(`henley-splide-prev-course-image-carousel-${controls_prev.dataset}`)
        );
      } else {
        window.dispatchEvent(new CustomEvent("henley-splide-prev"));
      }
    });
  }
  for (let i = 0; i < controls_next.length; i++) {
    controls_next[i].addEventListener("click", () => {
      if (
        "id" in controls_prev.dataset &&
        "event" in controls_prev.dataset &&
        controls_prev.dataset.event == "henley-splide-next-course-card-slide"
      ) {
        window.dispatchEvent(
          new CustomEvent(`henley-splide-next-course-card-slide-${controls_prev.dataset}`)
        );
      } else if (
        "id" in controls_prev.dataset &&
        "event" in controls_prev.dataset &&
        controls_prev.dataset.event == "henley-splide-next-course-image-carousel"
      ) {
        window.dispatchEvent(
          new CustomEvent(`henley-splide-next-course-image-carousel-${controls_prev.dataset}`)
        );
      } else {
        window.dispatchEvent(new CustomEvent("henley-splide-next"));
      }
    });
  }
}
